import StandsSync from "../../../utils/localDB/stands";
import StandsApi from "../stands";

class StandsManager {

    async getList(params) {
        if (params.isOffline) {
            return await new StandsSync().getList(params)
        }
        try {
            const result = await StandsApi.getList(params)
            window.postMessage('online')
            return result
        } catch (error) {
            const result = await new StandsSync().getList(params)
            window.postMessage('offline')
            return result
        }
    }
}

export default new StandsManager()
